import React, { useState } from 'react';
import styles from './Section4.module.scss';

const FAQPoint = ({ data }) => {
  const [isOpened, setIsOpened] = useState(false);
  return (
    <>
      <div className={`${styles.faqPointContainer}`}>
        <div
          className={`${styles.faqPointHeaderContainer}`}
          onClick={() => {
            setIsOpened(!isOpened);
          }}
        >
          <div className={`${styles.faqPointHeaderText}`}>{data.title}</div>
          <div className={`${styles.faqPointArrow}`}>
            <img
              width={'100%'}
              height={'100%'}
              src={`/assets/images/${isOpened ? 'upArrow' : 'downArrow'}.svg`}
              alt="arrow"
            />
          </div>
        </div>
        {isOpened && <div className={`${styles.faqPointText1}`}>{data.description}</div>}
      </div>
    </>
  );
};

export default FAQPoint;
